export default {
  'assessmentContext.title': 'Assessment Context',
  'assessmentContext.subtitle':
    'Design the unit and course structure of your assignment',
  'assessmentContext.unitCourse': 'UNITS / COURSES',
  'assessmentContext.noUnitSelected':
    'Select a unit or course to continue with the assessment setup.',
};
